import styled from "styled-components";
import { Anchor } from "@ebscois/react-component-library";

export const StyledAnchor = styled(Anchor)`
  line-height: 18px;
  font-weight: ${({ theme }) => theme.font.weight.bold};
  padding-bottom: 0.5rem;
  @media print {
    display: none;
  }
  font-weight: ${({ theme }) => theme.font.weight.semibold};
`;
